// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var RadioButtonInput$ReactHooksTemplate = require("../common/RadioButtonInput.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function MultipleChoicePreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var multipleChoice = props.multipleChoice;
  var onTitleChange = function (html) {
    Curry._1(onChange, MultipleChoice$ReactHooksTemplate.setText(multipleChoice, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, MultipleChoice$ReactHooksTemplate.setDescription(multipleChoice, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: MultipleChoice$ReactHooksTemplate.getTextTranslation(multipleChoice, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: MultipleChoice$ReactHooksTemplate.getDescriptionTranslation(multipleChoice, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Choices",
                              className: "text-aurometalsaurus text-sm mb-4 font-normal"
                            }),
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.mapWithIndex(MultipleChoice$ReactHooksTemplate.getChoicesTranslation(multipleChoice, SurveyLanguage$ReactHooksTemplate.name(language)), (function (param, param$1) {
                                          var id = param$1[0];
                                          return JsxRuntime.jsx("label", {
                                                      children: JsxRuntime.jsx(RadioButtonInput$ReactHooksTemplate.make, {
                                                            checked: MultipleChoice$ReactHooksTemplate.$eq(multipleChoice, id),
                                                            label: param$1[1],
                                                            handleChange: (function (param) {
                                                                Curry._1(onChange, MultipleChoice$ReactHooksTemplate.setAnswer(multipleChoice, id));
                                                              }),
                                                            className: "mb-2"
                                                          }),
                                                      className: "flex gap-1 text-sm font-normal"
                                                    }, id);
                                        })))
                            })
                      ],
                      className: "flex flex-col"
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = MultipleChoicePreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
